module.exports = __webpack_public_path__ + "img/pick_4.b2e3e750.png";